import { getTimeActionTemplate } from '@/screens/Order/Pages/Order.transform'
import { Button, Select } from 'antd'
import Modal from 'antd/lib/modal/Modal'
import { useState } from 'react'
import { useQuery } from 'react-query'
import './ModalTemplate.style.less'
import { find } from 'lodash'

interface Props {
  open: boolean
  onApply: (template) => void
  onClose: () => void
}

function ModalTemplate(props: Props) {
  const { onApply } = props
  const { data = [] } = useQuery('GET_TEMPLATES', async () => {
    return await getTimeActionTemplate()
  })

  const [selectedTemplate, setSelectedTemplate] = useState(null)
  const handleClickApply = () => {
    if (selectedTemplate) {
      const getTemplate = find(data, (elem) => elem.id === selectedTemplate)
      const jsonValue = JSON.parse(getTemplate.value)
      jsonValue.template_id = getTemplate.id

      onApply(jsonValue)
    }
  }

  return (
    <Modal
      onCancel={props.onClose}
      open={props.open}
      footer={false}
      width={400}
      className="modal-use-template-container"
    >
      <p>Use Template</p>
      <Select
        onChange={(value) => setSelectedTemplate(value)}
        placeholder="Select Template"
      >
        {data?.map((item) => (
          <Select.Option key={item.id} value={item.id}>
            {item.label}
          </Select.Option>
        ))}
      </Select>

      <Button onClick={() => handleClickApply()} type="primary" size="large">
        Apply
      </Button>
    </Modal>
  )
}

export default ModalTemplate
